import { render, staticRenderFns } from "./WarehouseAddDialog.vue?vue&type=template&id=3dafbbad&scoped=true"
import script from "./WarehouseAddDialog.vue?vue&type=script&lang=js"
export * from "./WarehouseAddDialog.vue?vue&type=script&lang=js"
import style0 from "./WarehouseAddDialog.vue?vue&type=style&index=0&id=3dafbbad&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dafbbad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dafbbad')) {
      api.createRecord('3dafbbad', component.options)
    } else {
      api.reload('3dafbbad', component.options)
    }
    module.hot.accept("./WarehouseAddDialog.vue?vue&type=template&id=3dafbbad&scoped=true", function () {
      api.rerender('3dafbbad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/WarehouseAddDialog.vue"
export default component.exports